import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_DELIMIT_REPORT_REQUEST,
  FETCH_DELIMIT_REPORT_SUCCESS,
  FETCH_DELIMIT_REPORT_ERROR,
} from 'actionTypes'

export const fetch = (token, param, callback) => (dispatch) => {
  if(param.statusType === "false" ||param.statusType === false) param.statusType = ""
  dispatch(actionSet(FETCH_DELIMIT_REPORT_REQUEST))
  return new Api(token, dispatch)
    .post(API_URL.DELIMIT_REPORT, param)
    .then((response) => {
      dispatch(getPages(response.metadata))
      dispatch(actionSet(FETCH_DELIMIT_REPORT_SUCCESS, response.data))
      if (callback) {
        callback(response.data, response.metadata.totalCount)
      }
    })
    .catch((error) => {
      dispatch(actionSet(FETCH_DELIMIT_REPORT_ERROR, error))
    })
    .finally(() => {})
}
